import configment from '@adc/configment'

export const getLatitude = listing => {
  return listing.primary_property?.summary?.address?.coordinates?.lat
}
export const getLongitude = listing => {
  return listing.primary_property?.summary?.address?.coordinates?.lon
}

const getEnhancedPhotoName = (url = '') => {
  if (!url || typeof url !== 'string') return ''
  return url.replace('.v1.', '-enhanced.v1.')
}

export const getListingImageUrl = (
  primaryPhoto,
  showEnhanced,
  _defaultPhotoUrl
) => {
  const defaultPhotoUrl =
    _defaultPhotoUrl || configment.get('LISTING_DEFAULT_PHOTO_URL', '')
  if (!primaryPhoto) {
    return defaultPhotoUrl
  }
  return showEnhanced ? getEnhancedPhotoName(primaryPhoto) : primaryPhoto
}

export const isListingOnline = listing => {
  return Boolean(
    listing.auction?.is_online ||
      listing.listing_configuration?.is_third_party_online
  )
}
